import { ConfirmationDialog } from "../../../common/ConfirmationDialog";
import React from "react";
import { ApiErrorHandler, useTranslation } from "hhn-commons";
import { useSnackbar } from "notistack";
import {
  IGroupInfo,
  ImmutableChat,
  IUserInfo,
} from "@home-health-notify/domain";

type RevokeReferralModalProps = {
  userInfo: IUserInfo;
  groupInfo: IGroupInfo;
  chat?: ImmutableChat;
  isOpen: boolean;
  onClose: () => void;
};

export const RevokeReferralModal = ({
  userInfo,
  groupInfo,
  chat,
  isOpen,
  onClose,
}: RevokeReferralModalProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });

  const onRevokeReferral = async () => {
    try {
      await chat?.revokeReferral(userInfo.id, groupInfo?.id);
      enqueueSnackbar(
        tNs("referral.invitationFor") +
          userInfo.name +
          tNs("referral.hasBeenRevoked"),
        {
          autoHideDuration: 3000,
        },
      );
    } catch (e) {
      if (e instanceof Error && e.name !== "ReferralRevokeFailException") {
        ApiErrorHandler(e, enqueueSnackbar);
      }
    } finally {
      onClose();
    }
  };

  return (
    <ConfirmationDialog
      isOpen={isOpen}
      onClose={onClose}
      confirmationTitle={tNs("referral.revokeReferral")}
      confirmationMessage={tNs("referral.confirmRevokeReferral")}
      confirmationButtonText={tNs("referral.revoke")}
      onConfirmationAction={() => onRevokeReferral()}
    />
  );
};
